import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";

import { SAL2100_R01Dto } from "./Dto_SAL2100_R01";
import { SAL2100_R01Filter } from "./Store_SAL2100_R01";

const baseUrl = `${config.apiUrl}/SAL2100_R01`;

const getSAL2100_R01Params = (filter: Partial<SAL2100_R01Filter>) => ({
	compCd: filter.compCd || undefined,
	year: filter.year,
	customCd: filter.customCd || undefined,
	brandCd: filter.brandCd || undefined,
	itemCd: filter.itemCd || undefined,
});

export const getSAL2100_R01SalesList = async (
	option: string,
	params: Partial<SAL2100_R01Filter>,
) => getData<ResponseDto<SAL2100_R01Dto>>(
	`${baseUrl}/sales/${option}`,
	{ params: getSAL2100_R01Params(params) },
);

export const getSAL2100_R01ItemGroupList = async (
	option: string,
	params: Partial<SAL2100_R01Filter>,
) => getData<ResponseDto<SAL2100_R01Dto>>(
	`${baseUrl}/itemGroup/${option}`,
	{ params: getSAL2100_R01Params(params) },
);

export const getSAL2100_R01BrandList = async (
	option: string,
	params: Partial<SAL2100_R01Filter>,
) => getData<ResponseDto<SAL2100_R01Dto>>(
	`${baseUrl}/brand/${option}`,
	{ params: getSAL2100_R01Params(params) },
);

export const downloadExcel_SAL2100_R01 = async (
	option: string,
	params: Partial<SAL2100_R01Filter>,
) => getData<ResponseDto<string>>(
	`${baseUrl}/excel/${option}`,
	{ params: getSAL2100_R01Params(params) },
);
